import { makeStyles } from '@material-ui/styles';
import useTypeTracking from '../../../../analytics';

import { GlobalLine, Text, TextButton } from '@bizzabo/design-system';
import { useUserSettings } from '../../../../settingsNav';
import currentTimeZoneIdAtom from '../../timeZoneId';
import { useAtomValue } from 'jotai';

const TimeZoneHeader: React.FC = () => {
    const classes = useStyles();
    const { openScheduledMeetings } = useUserSettings();
    const { trackClickEvent } = useTypeTracking();
    const timeZone = useAtomValue(currentTimeZoneIdAtom);

    const openSettings = () => {
        openScheduledMeetings();
        trackClickEvent({
            subCategory: 'OPEN_MEETING_SETTINGS',
            description: {
                flow: 'EDIT_SETTINGS',
            },
        });
    };

    return (
        <div className={classes.row}>
            <GlobalLine className={classes.globalIcon} />
            <Text variant="t81">Time Zone: {timeZone}</Text>
            <TextButton size="small" className={classes.settingsBtn} onClick={openSettings}>
                Meetings preferences
            </TextButton>
        </div>
    );
};

const useStyles = makeStyles(
    theme => ({
        row: {
            display: 'flex',
            alignItems: 'center',
            padding: '0 30px 32px',
            color: '#767676',
        },
        globalIcon: {
            width: 13,
            height: 13,
            marginRight: 5,
        },
        settingsBtn: {
            ...theme.typography.t81,
            padding: 0,
            marginLeft: '5px',
            color: '#272727',
            lineHeight: 1,
        },
    }),
    { classNamePrefix: 'meetings-time-zone-header' }
);

export default TimeZoneHeader;
